module.exports = __webpack_public_path__ + "img/shuxian1.5bfe2cce.png";